import { useEffect, useState } from 'react';
import { viewLeadClosureReasons } from 'services/lead/leadServices';

const useCaseCloseReason = (params) => {
  const { isLead = false, excludeFromLoading = false } = params || {};
  const [caseCloseReasonList, setCaseCloseReasonList] = useState([]);
  const [isCloseReasonLoading, setIsCloseReasonLoading] = useState(false);

  const loadCaseCloseReason = () => {
    setIsCloseReasonLoading(true);
    viewLeadClosureReasons(isLead, excludeFromLoading)
      .then((response) => {
        console.log('response ..............', response);
        let closeReasonData = [];
        if (response?.data) {
          closeReasonData = response?.data?.['closure-reason']?.map((val) => {
            return { label: val.closure_reason, value: val.closure_reason };
          });
        }
        setCaseCloseReasonList(closeReasonData);
      })
      .catch((error) => {
        console.log('error', error);
        setCaseCloseReasonList([]);
      })
      .finally(() => setIsCloseReasonLoading(false));
  };

  useEffect(() => {
    loadCaseCloseReason();
  }, []);

  return { caseCloseReasonList, isCloseReasonLoading };
};

export default useCaseCloseReason;
